import { useSimulationGroupStore } from '@/modules/simulation/useSimulationGroupStore';
import { ISimulationService } from '@/modules/simulation/service/ISimulationService';
import { SimulationServiceImpl } from '@/modules/simulation/service/SimulationServiceImpl';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';
import { SimulationServiceExceptionDecorator } from '@/modules/simulation/service/SimulationServiceExceptionDecorator';
import { SimulationServiceLogDecorator } from '@/modules/simulation/service/SimulationServiceLogDecorator';

export class SimulationServiceFactory {
  private static instance: SimulationServiceFactory | null = null;
  private simulationStore: typeof useSimulationGroupStore;
  private fddmStore: typeof useFloorplanDesignStore;
  private vehicleStore: typeof useVehicleStore;

  public static initialize(
    simulationStore: typeof useSimulationGroupStore,
    fddmStore: typeof useFloorplanDesignStore,
    vehicleStore: typeof useVehicleStore,
  ) {
    SimulationServiceFactory.instance = new SimulationServiceFactory(
      simulationStore,
      fddmStore,
      vehicleStore,
    );
  }

  public static getInstance() {
    if (SimulationServiceFactory.instance === null) {
      throw new Error(
        'SimulationServiceFactory not yet initialized. Call SimulationServiceFactory.initialize() first.',
      );
    }
    return SimulationServiceFactory.instance;
  }

  private constructor(
    simulationStore: typeof useSimulationGroupStore,
    fddmStore: typeof useFloorplanDesignStore,
    vehicleStore: typeof useVehicleStore,
  ) {
    this.simulationStore = simulationStore;
    this.fddmStore = fddmStore;
    this.vehicleStore = vehicleStore;
  }

  public createSimulationService(): ISimulationService {
    let result: ISimulationService = this.makeSimulationService();

    result = new SimulationServiceExceptionDecorator(result);
    result = new SimulationServiceLogDecorator(result);

    return result;
  }

  private makeSimulationService(): ISimulationService {
    return new SimulationServiceImpl(this.simulationStore, this.fddmStore, this.vehicleStore);
  }
}
